/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdDeletePreview200,
  GetApiV1ClassroomdisciplineIdDeletePreview401,
  GetApiV1ClassroomdisciplineIdDeletePreview404,
  GetApiV1ClassroomdisciplineIdDeletePreviewPathParams,
  GetApiV1ClassroomdisciplineIdDeletePreviewQueryResponse,
} from "../../types/classPlanningController/GetApiV1ClassroomdisciplineIdDeletePreview.ts";
import { deletePreviewViewModelSchema } from "../deletePreviewViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdDeletePreviewPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdDeletePreviewPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdDeletePreview200Schema = z.lazy(
  () => deletePreviewViewModelSchema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdDeletePreview200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdDeletePreview401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdDeletePreview401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdDeletePreview404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdDeletePreview404>;

export const getApiV1ClassroomdisciplineIdDeletePreviewQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdDeletePreview200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdDeletePreviewQueryResponse>;
